import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { CancelButton, SaveButton } from '../CreateClient/CreateClient.styles';
import translation from '../../../locales/en/translation.json';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function AddAccountModal({
  open,
  handleOpen,
  handleClose,
  form,
  onSubmit,
  is_executive,
}) {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography
            id="transition-modal-title"
            variant="h6"
            component="h2"
            sx={{
              marginBottom: '20px',
            }}
          >
            {is_executive
              ? translation.assign_account_executive
              : translation.assign_support_engineer}
          </Typography>
          {form && (
            <form onSubmit={onSubmit}>
              {form}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                  marginTop: '10px',
                }}
              >
                <SaveButton type="submit">{translation.save}</SaveButton>
                <CancelButton onClick={handleClose}>
                  {translation.cancel}
                </CancelButton>
              </Box>
            </form>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
